import { render } from "./ContentTableComponent.vue?vue&type=template&id=def8e68e&scoped=true"
import script from "./ContentTableComponent.vue?vue&type=script&lang=js"
export * from "./ContentTableComponent.vue?vue&type=script&lang=js"

import "./ContentTableComponent.vue?vue&type=style&index=0&id=def8e68e&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-def8e68e"]])

export default __exports__